import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { ShoppingBag, MousePointerClick } from "lucide-react";

const PERIODS = [[0, "Tout"], [7, "7 jours"], [30, "30 jours"]];

export function ProductClicks() {
  const [clicks, setClicks] = useState([]);
  const [days, setDays] = useState(0);

  const load = useCallback(() => {
    api.get("/admin/product-clicks", { params: { days } })
      .then((r) => setClicks(r.data)).catch(() => setClicks([]));
  }, [days]);
  useEffect(() => { load(); }, [load]);

  return (
    <Card className="border-gray-200 mb-8" data-testid="product-clicks-manager">
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
          <div className="flex items-center gap-2">
            <MousePointerClick className="w-5 h-5 text-emerald-700" />
            <h2 className="font-serif-display text-xl font-normal text-gray-800">Top des objets cliqués</h2>
          </div>
          <div className="flex gap-2">
            {PERIODS.map(([d, label]) => (
              <button key={d} onClick={() => setDays(d)} data-testid={`clicks-period-${d}`}
                className={`px-4 h-9 rounded-full text-sm font-semibold transition-colors ${days === d ? "bg-emerald-700 text-white" : "bg-white border border-gray-200 text-gray-600"}`}>
                {label}
              </button>
            ))}
          </div>
        </div>
        {clicks.length === 0 ? (
          <p className="text-sm text-gray-400">Aucun clic « Découvrir l'objet » sur cette période.</p>
        ) : (
          <div className="space-y-2">
            {clicks.map((c, i) => (
              <div key={i} className="flex items-center gap-3 rounded-xl border border-gray-200 p-3" data-testid={`product-click-row-${i}`}>
                <span className="w-8 h-8 rounded-lg bg-emerald-700 text-white font-bold flex items-center justify-center shrink-0 text-sm">{i + 1}</span>
                <span className="w-9 h-9 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center shrink-0"><ShoppingBag className="w-4 h-4" /></span>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-800 truncate">{c.product_name || "Objet"}</p>
                  <p className="text-xs text-gray-500 truncate">{c.game_title}</p>
                </div>
                <span className="shrink-0 px-3 h-8 rounded-full bg-emerald-50 text-emerald-700 font-bold text-sm inline-flex items-center">
                  {c.count} clic{c.count > 1 ? "s" : ""}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
